<template>
  <v-layout row>
    <v-flex xs12 sm12>
      <v-toolbar flat color="white">
        <v-tooltip bottom>
          <v-btn
            icon
            light
            @click="$router.push({ name: 'activeCall' })"
            slot="activator"
          >
            <v-icon color="grey darken-2">arrow_back</v-icon>
          </v-btn>
          <span>{{ $vuetify.t('$vuetify.app.back') }}</span>
        </v-tooltip>
        <v-toolbar-title
          >{{ $vuetify.t('$vuetify.calls.location') }}
        </v-toolbar-title>
        <v-spacer></v-spacer>
      </v-toolbar>
      <v-layout row wrap mt-3 mb-3 fill-height>
        <v-flex xs12 class="text-xs-center mt-3">
          <GmapMap
            :center="{ lat: this.latest.latitude, lng: this.latest.longitude }"
            :zoom="7"
            ref="mapRef"
            style="width: 100%; height: 100%;"
          >
            <GmapMarker
              :key="index"
              v-for="(m, index) in markers"
              :position="m.position"
              :clickable="true"
              :draggable="true"
            />
          </GmapMap>
          <div
            style="position:absolute;top:20vh;left:20vw;z-index:9999"
            v-if="this.directionsloading"
          >
            <v-progress-circular
              indeterminate
              size="128"
              width="16"
              color="white"
            ></v-progress-circular>
          </div>
        </v-flex>
        <v-flex xs12 class="text-xs-center mt-3" v-if="this.latestETA">
          <v-card>
            <v-alert :value="true" type="error" v-if="this.locationError">
              There was an error getting your location {{ this.locationError }}
            </v-alert>
            <v-card-title
              >Address: {{ this.getActiveCall.company }},
              {{ this.getActiveCall.address_line_1 }}
              {{ this.getActiveCall.postcode }}
            </v-card-title>
            <v-card-title
              >Time to Destination: {{ this.timeToDestination }}</v-card-title
            >
            <v-card-title
              >Distance: {{ this.distanceToDestination }}</v-card-title
            >
          </v-card>
        </v-flex>
        <v-flex v-else>
          <v-progress-circular indeterminate size="32"></v-progress-circular>
          Calculating...
        </v-flex>
      </v-layout>
    </v-flex>
  </v-layout>
</template>
<script>
import moment from 'moment'
import * as VueGoogleMaps from 'vue2-google-maps'
import { gmapApi } from 'vue2-google-maps'
import Vue from 'vue'
import formatting from '../mixins/formatting.js'

Vue.use(VueGoogleMaps, {
  /* load: {
      key: 'AIzaSyApyh6m_LiLL6IPYJ1nip-FvNaGJiDQSXg'
    }*/
  load: false
})
window.vueGoogleMapsInit(window.google)
import { mapActions, mapGetters, mapState } from 'vuex'

export default {
  name: 'Location',
  mixins: [formatting],
  data() {
    return {
      markers: [],
      center: {},
      dialog: false,
      map: null,
      directionsDisplay: null,
      activeCallWatcher: null,
      directionsloading: true,
      locationError: false
    }
  },
  mounted() {
    this.getLocation()
    this.$refs.mapRef.$mapPromise.then(map => {
      this.map = map
      this.directionsDisplay = new window.google.maps.DirectionsRenderer({
        preserveViewport: true
      })
      // this.renderDirections()
    })
  },
  methods: {
    ...mapActions({
      fetchLocation: 'location/fetch',
      recordLocation: 'location/record',
      getDirections: 'location/directions',
      changeCallPostcode: 'calls/changePostCode'
    }),
    renderDirections: function(directions) {
      const bounds = new window.google.maps.LatLngBounds()
      if (this.directionsDisplay) {
        this.directionsDisplay.suppressMarkers = true
        this.directionsDisplay.preserveViewport = true
        // const directions = this.directions.directions
        // console.log("########", directions)
        if (directions) {
          this.directionsDisplay.set('directions', null)
          this.directionsDisplay.setMap(this.map)
          this.directionsDisplay.setDirections(directions)
          bounds.union(directions.routes[0].bounds)
          this.map.fitBounds(bounds)
          this.directionsloading = false
        } else {
          this.directionsloading = true
        }
      }
    },
    getLocation() {
      this.fetchLocation()
        .then(pos => {
          this.recordLocation(pos.coords)
            .then(r => {
              const origin = new window.google.maps.LatLng(
                pos.coords.latitude,
                pos.coords.longitude
              )
              if (this.getActiveCall) {
                const destination = new window.google.maps.LatLng(
                  this.getActiveCall.latitude,
                  this.getActiveCall.longitude
                )
                const routeParams = {
                  callId: this.getActiveCall.id,
                  origin: origin,
                  destination: destination
                }
                this.getDirections(routeParams)
                  .then(directions => {
                    this.renderDirections(directions)
                  })
                  .catch(e => {
                    this.directionsloading = false
                    this.locationError = e
                  })
              }
            })
            .catch(e => {
              console.error(e)
              this.directionsloading = false
              this.locationError = true
              this.getLocation()
            })
        })
        .catch(e => {
          console.error(e)
          this.directionsloading = false
          this.locationError = true
        })
    }
  },
  computed: {
    ...mapState({
      latest: state => state.location.latest,
      directions: state => state.location.directions,
      eta: state => state.location.eta
    }),
    ...mapGetters({
      latestLocation: 'location/latestLocation',
      latestETA: 'location/latestETA',
      latestDirections: 'location/latestDirections',
      getActiveCall: 'calls/getActiveCall'
    }),
    google: gmapApi,

    timeToDestination: function() {
      return this.latestETA.eta && this.latestETA.eta.duration
        ? this.latestETA.eta.duration.text
        : 'unknown'
    },

    distanceToDestination: function() {
      return this.latestETA.eta && this.latestETA.eta.distance
        ? this.formatMetresToMiles(this.latestETA.eta.distance.value)
        : 'unknown'
    }
  }
  /*
  watch: {
    latestLocation: function () {
      this.renderDirections()
    },
    latestETA: function () {
      this.renderDirections()
    },
    latestDirections: function () {
      this.renderDirections()
    }
  }
  */
}
</script>
<style scoped>
.vue-map-container,
.vue-map-container .vue-map {
  width: 100%;
  height: 100%;
}
</style>
